// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PostCall_wrapper__3ekCR"};